/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mPass.vue?vue&type=template&id=08600cb5"
import script from "./mPass.vue?vue&type=script&lang=js"
export * from "./mPass.vue?vue&type=script&lang=js"
import style0 from "./mPass.vue?vue&type=style&index=0&id=08600cb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports